export const TOGGLE_DAYS_FILTER_MENU = 'ibw/SearchDays/TOGGLE_DAYS_FILTER_MENU';
